import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-statistics',
  templateUrl: './select-statistics.component.html',
  styleUrls: ['./select-statistics.component.scss']
})
export class SelectStatisticsComponent implements OnDestroy {

  public items: any[] = [
    { name: 'Acumulado', value: 'accum' },
    { name: 'Promedio', value: 'avg' },
    { name: 'Acum y Prom', value: 'both' }
  ];

  public statisticSelected: any = [];
  public ngxDisabled = true;
  statisticSelected$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.statisticSelected$ = sharedService.sharedStatistic.subscribe((statisticSelected: string) => {
      if (this.statisticSelected !== statisticSelected) {
        this.statisticSelected = statisticSelected;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.statisticSelected$.unsubscribe();
  }

  changeVariable(event: any) {
    this.statisticSelected = event;
    this.sharedService.nextStatistic = this.statisticSelected;
  }

}